<template>
    <div class="mt-4">
        <div class="container">
            <div class="card-body rcorners2">
                <div style="padding-top: 65px;" class="steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x">
                    
                    <div class="step" v-bind:class="{ completed: created }">
                        <div class="step-icon-wrap">
                            <div class="step-icon"><i class="fas fa-clipboard-list"></i></div>
                        </div>
                        <h4 class="step-title">Creado</h4>
                    </div>

                    <div v-if="!cancelled" class="step" v-bind:class="{ completed: send }">
                        <div class="step-icon-wrap">
                            <div class="step-icon"><i class="fas fa-paper-plane"></i></div>
                        </div>
                        <h4 class="step-title">Enviado</h4>
                    </div>

                    <div class="step validation">
                        <!-- Subpaso Enología -->
                        <div class="sub-step top" v-bind:class="{ completed: allDeliveryDateOenology, pending: !allDeliveryDateOenology }">
                            <div v-if="allDeliveryDateOenology && send" style="background-color: #28a745 !important;" class="sub-step-icon"><i class="fas fa-flask mr-1"></i> Validación Enología <i title="Muestras Pendientes en Enología" class="fa fa-exclamation-triangle ml-2" v-if="!allDeliveryDateOenology"></i></div>
                            <div v-if="!allDeliveryDateOenology && send" style="background-color: #d3af10 !important;" class="sub-step-icon"><i class="fas fa-flask mr-1"></i> Validación Enología <i title="Muestras Pendientes en Enología" class="fa fa-exclamation-triangle ml-2" v-if="!allDeliveryDateOenology"></i></div>
                            <div v-if="!send" style="background-color: #f5f5f5 !important; color: #374250 !important;" class="sub-step-icon"><i class="fas fa-flask mr-1"></i> Validación Enología </div>
                        </div>

                        <!-- Punto Principal -->
                        <div class="step-icon-wrap" v-bind:class="{ completed: allDeliveryDateOenology && allWineryValid, pending: !allDeliveryDateOenology || !allWineryValid }">
                            <div class="step-icon" v-if="send" v-bind:class="{ 'step-icon-wrap-completed': allWineryValid && allDeliveryDateOenology, 'step-icon-wrap-pending': !allDeliveryDateOenology || !allWineryValid  }"><i class="fas fa-check-double"></i></div>
                            <div class="step-icon" v-if="!send" ><i class="fas fa-check-double"></i></div>

                        </div>
                        <h4 class="step-title">Validación</h4>

                        <!-- Subpaso Componentes -->
                        <div class="sub-step bottom" v-bind:class="{ completed: allWineryValid , pending: !allWineryValid }">
                            <div v-if="allWineryValid && send" style="background-color: #28a745 !important;" class="sub-step-icon"><i class="fas fa-tasks mr-1"></i> Validación Componentes <i title="Muestras Pendientes de Validación de Componentes" class="fa fa-exclamation-triangle ml-2" v-if="!allWineryValid"></i></div>
                            <div v-if="!allWineryValid && send" style="background-color: #d3af10 !important;" class="sub-step-icon"><i class="fas fa-tasks mr-1"></i> Validación Componentes <i title="Muestras Pendientes de Validación de Componentes" class="fa fa-exclamation-triangle ml-2" v-if="!allWineryValid"></i></div>
                            <div v-if="!send" style="background-color: #f5f5f5 !important; color: #374250 !important;" class="sub-step-icon"><i class="fas fa-tasks mr-1"></i> Validación Componentes </div>

                        </div>
                    </div>

                    <div class="step" v-bind:class="{ completed: validQuality }">
                        <div class="step-icon-wrap">
                            <div class="step-icon"><i class="fas fa-calendar-check"></i></div>
                        </div>
                        <h4 class="step-title">Calidad</h4>
                    </div>

                    <div v-if="!invalid && !cancelled" class="step" v-bind:class="{ completed: wineryDispatched }">
                        <div class="step-icon-wrap">
                            <div class="step-icon"><i class="fas fa-truck"></i></div>
                        </div>
                        <h4 class="step-title">Despachado Bodega</h4>
                    </div>

                    <div v-if="!rejected && !invalid && !cancelled" class="step" v-bind:class="{ completed: dispatched }">
                        <div class="step-icon-wrap">
                            <div class="step-icon"><i class="fas fa-plane-departure"></i></div>
                        </div>
                        <h4 class="step-title">Despachado</h4>
                    </div>

                    <div v-if="!rejected && !invalid && !cancelled" class="step" v-bind:class="{ completed: confirmed }">
                        <div class="step-icon-wrap">
                            <div class="step-icon"><i class="fas fa-check"></i></div>
                        </div>
                        <h4 class="step-title">Confirmado</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ["status","allWineryValid", "allDeliveryDateOenology"],
	data() {
		return {
			created: false,
			send: false,
			validWineryDispatch: false,
			wineryDispatched: false,
			validComponents: false,
			validQuality: false,
			dispatched: false,
			confirmed: false,
			validToDispatcher: false,
			anyWineryDispatch: false,
			invalid: false,
			rejected: false,
			cancelled: false,
			rejectQuality: false,
			partialArrived: false
		};
	},
	created() {
        if (this.status === "Cancelado por Solicitante") {
            this.created = true;
            this.cancelled = true;
        }
        if (this.status === "Creado") 
            this.created = true;
        if (this.status === "Enviado") {
            this.created = true;
            this.send = true;
        }
        if (this.status === "Invalidado desde Enología") {
            this.created = true;
            this.send = true;
            this.invalid = true;
        }
        if (this.status === "En validación de Enología") {
            this.created = true;
            this.send = true;
            this.validWineryDispatch = true;
        }
        if (this.status === "Componentes en Revisión") {
            this.created = true;
            this.send = true;
            this.validWineryDispatch = true;
        }
        if (this.status === "Calidad") {
            this.created = true;
            this.send = true;
            this.validWineryDispatch = true;
            this.validToDispatcher = true;
            this.validComponents = true;
        }
        if (this.status === "Válido para Despacho") {
            this.created = true;
            this.send = true;
            this.validComponents = true;
            this.validWineryDispatch = true;
            this.validQuality = true;
        }
        if (this.status === "Rechazo por Calidad") {
            this.created = true;
            this.send = true;
            this.validComponents = true;
            this.validWineryDispatch = true;
            this.rejectQuality = true;
        }
        if (this.status === "Rechazado") {
            this.created = true;
            this.send = true;
            this.validWineryDispatch = true;
            this.rejected = true;
        }
        if (this.status === "Despachado Bodega") {
            this.created = true;
            this.send = true;
            this.validWineryDispatch = true;
            this.wineryDispatched = true;
            this.validComponents = true;
            this.validToDispatcher = true;
            this.validQuality = true;
        }
        if (this.status === "Despachado") {
            this.created = true;
            this.send = true;
            this.validWineryDispatch = true;
            this.wineryDispatched = true;
            this.dispatched = true;
            this.validComponents = true;
            this.validToDispatcher = true;
            this.validQuality = true;
        }
        if (this.status === "Confirmado") {
            this.created = true;
            this.send = true;
            this.validWineryDispatch = true;
            this.wineryDispatched = true;
            this.dispatched = true;
            this.confirmed = true;
            this.validQuality = true;
            this.validComponents = true;
            this.validToDispatcher = true;
            this.partialArrived = false;
        }
        if (this.status === "Arribado Parcialmente")
        {
            this.created = true;
            this.send = true;
            this.validWineryDispatch = true;
            this.wineryDispatched = true;
            this.dispatched = true;
            this.confirmed = false;
            this.validQuality = true;
            this.validComponents = true;
            this.validToDispatcher = true;
            this.partialArrived = true;
        }
	}
};
</script>
